module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-33.7c819ba2.png";